import { useEffect, useMemo, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import ReactHlsPlayer from "react-hls-player";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useUser } from "../../context/UserContext";
import { Api } from "../../services/api";
import useWakeLock from "../../hooks/useWakeLock";

export default function Detail() {
  let { id } = useParams();
  const sessionUri = "/api/conference-sessions/" + id;
  const { user } = useUser();
  const api = useMemo(() => new Api(), []);
  const [video, setApiUser] = useState(null);
  const playerRef = useRef();

  useWakeLock(playerRef);

  useEffect(() => {
    const getData = async () => {
      const response = await api.getWithAuth(sessionUri, user);
      const json = await response.json();
      if (json.errors) {
        toast.error(json.errors.map((e) => e.message).join("\n"));
        return;
      }
      setApiUser(json);
    };
    getData();
  }, [user, api]);

  return (
    video && (
      <div className="wrapper">
        <Helmet>
          <title>{video.title} | EcommerceWeek 2026</title>
        </Helmet>
        <ReactHlsPlayer
          playerRef={playerRef}
          src={video.videoURL} // The last video updated in the backend having type live is played
          autoPlay={true}
          muted={true}
          controls={true}
          width="100%"
          height="auto"
          hlsConfig={{
            xhrSetup: function (xhr, url) {
              xhr.withCredentials = false;
            },
          }}
          onContextMenu={(e) => e.preventDefault()}
          controlsList="nodownload"
        />
      </div>
    )
  );
}
